/**
 * The redirect the three old Governance → Integrations routes throw: each
 * old address to its Apps address (appsPaths.legacyIntegrationsRedirect).
 *
 * @module components/apps/legacyIntegrationsRoute
 */
import { redirect } from "@tanstack/react-router";

import { legacyIntegrationsRedirect } from "./appsPaths";

export function redirectLegacyIntegrations(pathname: string, org: string): never {
  const target = legacyIntegrationsRedirect(pathname) ?? { to: "/$org/apps" as const };
  switch (target.to) {
    case "/$org/apps/$appId":
      throw redirect({ to: target.to, params: { org, appId: target.appId }, replace: true });
    case "/$org/apps/custom/$serverId":
      throw redirect({ to: target.to, params: { org, serverId: target.serverId }, replace: true });
    default:
      throw redirect({ to: "/$org/apps", params: { org }, replace: true });
  }
}
